<template>
  <table class="table table-sm color">
    <caption class="caption table-caption">Line Metrics</caption>
    <tbody>
      <tr>
        <th class="text-left font-weight-normal">Rate on Line</th>
        <td class="text-right" v-if="lineMetrics != undefined">{{lineMetrics.rateOnLine}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Loss on Line</th>
        <td class="text-right" v-if="lineMetrics != undefined">{{lineMetrics.lossOnLine}}</td>
      </tr>
      <tr>
        <th class="text-left font-weight-normal">Margin on Line</th>
        <td class="text-right" v-if="lineMetrics != undefined">{{lineMetrics.returnOnLine}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["lineMetrics"]
}
</script>

